<div class="platform-bottom-container">
  <div class="content">
    <div class="links">
      <ng-content select="[links]"></ng-content>
    </div>
    <div class="copyright">
     <ng-content select="[copyright]"></ng-content>
    </div>
  </div>
</div>
